import { ApiUrl2,UserToken } from '../../../helper/HelperAuth'
import { GlobalLoading } from '../../../store/constants'
import doFetch from '../../../infra/helper/fetchHelper'
import saveStreamCSV from '../../../infra/helper/saveStreamCSV'

export default (jobid, type) => async (dispatch, getState) => {
    dispatch({ type: GlobalLoading, showLoading: true, latestProcessStatus: false });

    var body = {"jobid":jobid};
    var fileName = jobid+"_"+type+"_validationErrorDetail"
    const Authorization = UserToken;
    const url = ApiUrl2 + 'download-validationfile';
    const argument = {
        method: 'POST',
        headers : {
            'Authorization': Authorization,
        },
        body : JSON.stringify(body)
    };

    const response = await doFetch(url,argument);
    if(response.ok){
        var responseText = await response.text();
        saveStreamCSV(`${fileName}.csv`, responseText)
    }
    dispatch({ type: GlobalLoading, showLoading: false, latestProcessStatus : response.ok });
    return response;
};